// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__8vYa5","resendInfoText":"OnGoingPaymentBox_resendInfoText__3VxkC"};